import React from 'react';
import styles from '../curriculum/curriculum.module.css';
import styles2 from './day-schedule.module.css'

const DaySchedule: React.FC = () => {


    return (
        <section className={styles.section_container}>
            <div className={styles.content_wrapper}>
                <div className={styles.image_container}>
                    <img
                        src="/images/programs/clock.jpg"
                        alt="Espace chaleureux de la garderie"
                        className={styles.image}
                    />
                </div>
                <h2 className={styles.section_title}>
                    {"Horraire de la  journée"}
                </h2>

                <div className={styles.image_container2}>
                    <img
                        src="/images/programs/schedule.png"
                        alt="Espace chaleureux de la garderie"
                        className={styles.image2}
                    />
                </div>
                {/*<div className={styles2.text_content}>*/}
                {/*    <div className={styles2.schedule}>*/}
                {/*        <h5>7-8am Accueil</h5>*/}
                {/*        <p> is simply dummy text of the printing and typesetting industry.*/}
                {/*            Lorem Ipsum has been the industry's standard dummy</p>.*/}

                {/*        <h5>8-9am Collation matinale</h5>*/}
                {/*        <p> is simply dummy text of the printing and typesetting industry.*/}
                {/*            Lorem Ipsum has been the industry's standard dummy</p>*/}

                {/*        <h5>9-11am Activité matinale</h5>*/}
                {/*        <p> is simply dummy text of the printing and typesetting industry.*/}
                {/*            Lorem Ipsum has been the industry's standard dummy</p>*/}

                {/*        <h5>11-12:30pm Dinner</h5>*/}
                {/*        <p> repas fait maison et adapter au besion des enfants</p>*/}
                {/*    </div>*/}
                {/*    <div className={styles2.schedule}>*/}

                {/*        <h5>12:30/1:00-3pm Sieste</h5>*/}
                {/*        <p> is simply dummy text of the printing and typesetting industry.*/}
                {/*            Lorem Ipsum has been the industry's standard dummy</p>.*/}

                {/*        <h5>3pm Collation</h5>*/}
                {/*        <p> is simply dummy text of the printing and typesetting industry.*/}
                {/*            Lorem Ipsum has been the industry's standard dummy</p>*/}

                {/*        <h5>activité matinale</h5>*/}
                {/*        <p> is simply dummy text of the printing and typesetting industry.*/}
                {/*            Lorem Ipsum has been the industry's standard dummy</p>*/}

                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </section>
    );
};

export default DaySchedule;
